import { ComplianceRepository } from "../../repositories/ComplianceRepository";
import { MasterComplianceCalendarEntity, GroupedCalendarEntries } from "../../entities/MasterComplianceCalendarEntity";

export class GetCalendarEntriesUseCase {
  constructor(private repository: ComplianceRepository) {}

  async execute(filters?: {
    compliance_type_id?: number;
    period?: string;
    is_active?: boolean;
  }): Promise<MasterComplianceCalendarEntity[]> {
    return await this.repository.getCalendarEntries(filters);
  }
}

export class GetCalendarEntriesGroupedUseCase {
  constructor(private repository: ComplianceRepository) {}

  async execute(): Promise<GroupedCalendarEntries> {
    return await this.repository.getCalendarEntriesGrouped();
  }
}

